import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isNotEmptyString, isValidEmail } from "../utils/common/validate";
import { DefaultMessages, ErrorMessages } from "../utils/constants/Labels";
import { generateLog } from "../utils/constants/Logger";
import Layout from "./common/Layout";
import { setStorage } from "../utils/common/StorageController";
import {
  showToastError,
  showToastSuccess,
} from "../utils/common/ToastController";
import { appGalleryService } from "../services/ApiService";
import "../App.css";

function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showSignUp, setShowSignUp] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const newErrors = { email: "", password: "" };

    if (!isNotEmptyString(email)) {
      newErrors.email = ErrorMessages.EmailRequired;
    } else if (!isValidEmail(email)) {
      newErrors.email = ErrorMessages.InvalidEmail;
    }

    if (!isNotEmptyString(password)) {
      newErrors.password = ErrorMessages.PasswordRequired;
    }

    setErrors(newErrors);

    if (Object.values(newErrors).every((error) => error === "")) {
      let payLoad = {
        Email: email,
        Password: password,
      };

      appGalleryService
        .signIn(payLoad)
        .then((response) => {
          console.log("Full API Response:", response);
          generateLog("default", SignIn.name, "Sign-In API Response", response);

          if (response.status === true) {
            showToastSuccess(DefaultMessages.SuccessLogin);

            navigate("/LandingPage");
          } else {
            showToastError(response.message);
          }
        })
        .catch((error) => {
          generateLog("error", SignIn.name, "Sign-In API Error", error);
        });
    }
  };
  const handleSignUpClick = () => {
    // Navigate to SignUp component
    navigate("/signup");
  };
  return (
    <>
      <Layout pageName="sidenav">
        <div className="row">
          <div className="col-4 pe-0">
            <div className="card-ai-for-support">
              <div className="d-flex align-items-center h-100 pb-10">

                <img
                  src="logo-flex.png"
                  alt=""
                  width="110"
                  height="65"
                  className="grayscale-1 mb-0 me-3"
                />


                <p className="txt-dark-junglee-green fs-12 fw-semibold mb-0">
                  A customisable business chatbot platform that offers greater user engagement.
                </p>


              </div>
            </div>
            <div className="d-flex">
              <div className="card-ai-workflow">
                <h6 className="text-center fw-bold">AI Workflows</h6>
              </div>
              <div className="card-ai-for-distribuiton-networks">


                <div className="d-flex align-items-center justify-content-between h-100 align-items-center" >
                  <img
                    src="social.png"
                    alt=""
                    width="102"
                    height="60"
                    className="grayscale-1 me-3"
                  />
                  <p className="txt-dark-junglee-green fs-12 fw-semibold mb-0">
                    Connect Privately, Share Securely: Your Exclusive Community Space.
                  </p>
                </div>
              </div>
            </div>
            <div className="d-flex">
              <div className="card-custom-gpts">
                <h6 className="text-center fw-bold">Custom GPTs</h6>
              </div>
              <div className="card-ai-for-sales-team">
                <div className="d-flex align-items-center h-100">
                  <img
                    src="steno.png"
                    alt=""
                    width="102"
                    height="60"
                    className="grayscale-1 me-3 mw-105"
                  />
                  <p className="txt-dark-junglee-green fs-12 fw-semibold mb-0">


                    An AI-powered translator plugin that eliminates language barriers.
                  </p>


                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="card-procurement-ai-solution">
              <div className="d-flex justify-content-between align-items-center h-100 pb-10">

                {" "}
                <img
                  src="elevate.png"
                  alt=""
                  width="102"
                  height="60"
                  className="grayscale-1 me-3"
                />
                <p className="txt-dark-junglee-green fs-12 fw-semibold mb-0">

                  Elevate offers tailor-made chatbots designed for seamless integration
                  into your internal workflows and customer service, ensuring your data remains private and secure.
                </p>




              </div>


            </div>
            <div className="card-ai-data-transformation">
              <div className="d-flex justify-content-between w-100 h-100 align-items-center pb-10">




                <img
                  src="Collab.png"
                  alt=""
                  width="154"
                  height="58"
                  className="grayscale-1 me-3"
                />
                <p className="txt-dark-junglee-green fs-12 fw-semibold mb-0">
                  An AI-embedded collaboration portal helping communities of users.
                </p>
              </div>
            </div>
            <div className="card-ai-data-transformation">
              <div className="d-flex justify-content-between w-100 h-100 align-items-center pb-10">
              <img
                  src="logo-grasp.png"
                  alt=""
                  width="158"
                  height="58"
                  className="grayscale-1 me-3"
                />
                  
                  <p className="txt-dark-junglee-green fs-12 fw-semibold mb-0">
                    An AI document and image reader that streamlines data transformation.
                  </p>
                
                
              </div>
            </div>
            {/* <div className="d-flex">
            <div className="card-ai-document-reader mr-16">
              <h6 className=" fw-bold fs-18">
                Grasp
              </h6>
              <p className="txt-dove-grey fs-12 m-0">
                
              </p>
              <div className=" d-flex justify-content-end">

              </div>
            </div>
            <div className="card-translation-ai d-flex  align-items-center">
              <img
                src="logo-grasp.png" className="d-flex mx-auto align-items-center grayscale-1 mt-3"
                alt=""
                width="100"
                height="61"
              />
            </div>
          </div> */}
          </div>
          <div className="col-4">
            <div className="login-card">
              <h5>
                <i>Empowering</i>
              </h5>
              <h5 className="mb-2">
                <i>
                  Growth Through <b>AI</b>
                </i>
              </h5>
              <form onSubmit={submitHandler}>
                <div className="form-group">
                  <label className="txt-dark-junglee-green fs-12">
                    Username
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? 'error-border' : ''}`}
                    aria-describedby="usernamehelp"
                    placeholder="Enter Email Address"
                    name="email"
                    value={email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <div className="error-message text-danger">
                      {errors.email}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="txt-dark-junglee-green fs-12">
                    Password
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.password ? 'error-border' : ''}`}
                    id="exampleInputPassword1"
                    placeholder="Enter Password"
                    name="password"
                    value={password}
                    onChange={handleChange}
                  />
                  {errors.password && (
                    <div className="error-message text-danger">
                      {errors.password}
                    </div>
                  )}
                </div>
                <button type="submit" className="btn orange-btn mt-26 mb-8">
                  Login
                </button>
                {/* <button
                  className="btn black-outlined-btn mb-1"
                  onClick={handleSignUpClick}
                >
                  Sign Up
                </button> */}
              </form>
              <p className="txt-dark-junglee-green text-center fs-12 lh-14 mb-4 mt-1">
                Login or Signup to experience live demo Get in touch for your
                own customized AI Solution
              </p>
              <a href="https://www.incepteo.com/contact-us/" target="_blank" className="text-decoration-underline text-center text-dark fs-16 d-block">
                Book a Discovery Call
              </a>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
export default SignIn;
